// extracted by mini-css-extract-plugin
export var centerText = "_bz-8";
export var container = "_bz-0";
export var doughnutContainer = "_bz-7";
export var legend = "_bz-a";
export var legendItemColorDisplay = "_bz-b";
export var legendItemLabel = "_bz-d";
export var legendItemValue = "_bz-c";
export var lg = "_bz-5";
export var maxWidth = "_bz-9";
export var md = "_bz-4";
export var responsive = "_bz-6";
export var sm = "_bz-3";
export var xs = "_bz-2";
export var xxs = "_bz-1";